export default "__VITE_ASSET__rpifM8s3__"